enum AccessSummaryEditChartColorsElementEnum {
  ChartPercentage1 = "chartPercentage1",
  ChartPercentage1Color = "chartPercentage1Color",
  ChartPercentage2 = "chartPercentage2",
  ChartPercentage2Color = "chartPercentage2Color",
  ChartPercentage3 = "chartPercentage3",
  ChartPercentage3Color = "chartPercentage3Color",
  ChartPercentage4Color = "chartPercentage4Color",
}

export { AccessSummaryEditChartColorsElementEnum };
